import { useState, useEffect } from "react";
import Layout from "../../hocs/Layout";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { Row, Col, Button, Card, Form, Container } from "react-bootstrap/";
import logo_login from "../../media/img/Iniciar sesion_final.png";
import logo_pregunta from "../../media/img/olvidado_icon.png";
import { connect } from "react-redux";
import { login } from "../../redux/actions/auth";
import { Circles } from "react-loader-spinner";
import { TextInput } from "../../components/inputs/Inputs";
import { useForm } from "react-hook-form";
import { loginSchema } from "../../utils/validationSchemas";
import { yupResolver } from "@hookform/resolvers/yup";

const Login = ({ login, isAuthenticated, authResolved }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const defaultValues = {
    email: "",
    password: "",
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(loginSchema),
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  if (!authResolved) {
    return (
      <Layout>
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando sesión</span>
          </div>
        </div>
      </Layout>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const onSubmit = async () => {
    const data = getValues();
    setLoading(true);
    await login(data.email, data.password);
    setLoading(false);
  };

  return (
    <Layout>
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col md={5} lg={4} sm={8} xs={12}>
              <Card className="border-0 shadow-lg rounded-4 overflow-hidden">
                <Card.Header className="bg-white border-bottom-0 pt-5 pb-0 text-center">
                  <div className="mb-3 d-inline-block p-3 rounded-circle bg-light shadow-sm">
                    <img
                      width="40"
                      src={logo_login}
                      className="img-fluid"
                      alt="login"
                    />
                  </div>
                  <h2 className="text-primary fw-bold mb-0">Iniciar sesión</h2>
                </Card.Header>
                <Card.Body className="p-4 p-md-5">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                      <TextInput
                        register={register}
                        name="email"
                        label="Usuario / Email"
                        error={errors.email?.message}
                        className="mb-3"
                      />
                      <TextInput
                        register={register}
                        name="password"
                        label="Contraseña"
                        error={errors.password?.message}
                        type="password"
                      />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Link to="/reset_password" className="text-decoration-none small fw-bold text-muted">
                        ¿Has olvidado la contraseña?
                      </Link>
                    </div>

                    <div className="d-grid gap-2">
                      {loading ? (
                        <Button variant="primary" className="rounded-pill py-2 shadow-sm" disabled>
                          <div className="d-flex justify-content-center">
                            <Circles type="Oval" color="#fff" width={20} height={20} />
                          </div>
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          disabled={!isValid}
                          variant="primary"
                          className="rounded-pill py-2 fw-bold shadow-sm"
                        >
                          Acceder
                        </Button>
                      )}
                    </div>
                  </Form>

                  <div className="mt-4 text-center text-muted small">
                    <p className="mb-0">
                      Si desea ser agente colaborador de ab energía, <br />
                      contacte con nosotros en el <span className="fw-bold text-primary">900 1903 00</span>
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};
const mapStateToProps = (state) => ({
  authResolved: state.Auth.authResolved,
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  login,
})(Login);
